import React from 'react';
import { Typography, Button, Paper, Grid, Box } from '@mui/material';
import PlanCard from '../PlanCard';
import AddIcon from '@mui/icons-material/Add';

/**
 * Home screen component that displays saved plans and create new plan button
 */
const HomeScreen = ({ plans, onStartNewPlan, onLoadPlan, onEditPlan, onDeletePlan }) => {
  console.log('HomeScreen: Rendering with plans:', plans?.length, plans);
  
  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: 3, 
        mt: 4,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        zIndex: 100,
        position: 'relative',
        backgroundColor: 'background.paper'
      }}
    >
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        mb: 3
      }}>
        <Typography variant="h5" component="h1" sx={{ fontWeight: 600 }}>
          Race Plans
        </Typography>
        
        <Button 
          variant="contained" 
          startIcon={<AddIcon />}
          onClick={onStartNewPlan}
          sx={{ 
            borderRadius: 8,
            boxShadow: 'none',
            '&:hover': {
              boxShadow: '0 4px 12px rgba(18, 78, 102, 0.2)'
            },
          }}
        >
          New Plan
        </Button>
      </Box>
      
      {Array.isArray(plans) && plans.length > 0 ? (
        <>
          <Typography 
            variant="body2" 
            color="text.secondary" 
            sx={{ mb: 3 }}
          >
            Select a plan to view or edit, or create a new plan. {plans.length} plans found.
          </Typography>
          
          <Grid container spacing={3}>
            {plans.map((plan) => (
              <Grid item xs={12} sm={6} md={4} key={plan.id}>
                <PlanCard
                  plan={plan}
                  onEdit={onEditPlan}
                  onDelete={onDeletePlan}
                  onClick={() => onLoadPlan(plan)}
                />
              </Grid>
            ))}
          </Grid>
        </>
      ) : (
        <Box 
          sx={{ 
            textAlign: 'center', 
            py: 8,
            position: 'relative',
            minHeight: 300,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '60%',
              maxWidth: 400,
              height: '60%',
              backgroundImage: 'url(/ultrapackr.png)',
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              opacity: 0.03,
              zIndex: 0,
              pointerEvents: 'none'
            }
          }}
        >
          <Box sx={{ position: 'relative', zIndex: 1 }}>
            <Typography variant="body1" gutterBottom>
              You don't have any saved race plans yet.
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Create a new plan or import one to get started.
            </Typography>
          </Box>
        </Box>
      )}
    </Paper>
  );
};

export default HomeScreen; 